module.exports = __webpack_public_path__ + "static/media/error.4c412ab4.png";